import React, { useState, useEffect } from "react";
import EditGroupModal from "./EditGroupModal";
import { supabase } from "../supabase";

function GroupList({ userId }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const { data, error } = await supabase
          .from("tv_groups")
          .select(
            `
            *,
            tv_devices (
              id
            ),
            slides_config (
              id,
              slides_path
            )
          `
          )
          .eq("created_by", userId)
          .order("name");

        if (error) throw error;
        setGroups(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGroups();

    // Subscribe to changes
    const channel = supabase
      .channel("group_changes")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "tv_groups",
          filter: `created_by=eq.${userId}`,
        },
        fetchGroups
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  if (!groups.length)
    return <div>No groups found. Create one to get started.</div>;

  return (
    <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {groups.map((group) => (
        <div key={group.id} className="border rounded-lg p-4 bg-gray-50">
          <h3 className="font-semibold">{group.name}</h3>
          <p className="text-sm text-gray-600">
            TVs: {group.tv_devices?.length || 0}
          </p>
          <p className="text-sm text-gray-600">
            Has Content: {group.slides_config?.length ? "Yes" : "No"}
          </p>
          <div className="flex gap-2 mt-2">
            <button
              onClick={() => {
                setSelectedGroup(group);
                setIsModalOpen(true);
              }}
              className="text-sm text-indigo-600 hover:text-indigo-900"
            >
              Edit
            </button>
            <button
              onClick={async () => {
                try {
                  const { error } = await supabase
                    .from("tv_groups")
                    .delete()
                    .eq("id", group.id);

                  if (error) throw error;
                } catch (err) {
                  setError(err.message);
                }
              }}
              className="text-sm text-red-600 hover:text-red-900"
            >
              Delete
            </button>
          </div>
        </div>
      ))}{" "}
      {selectedGroup && (
        <EditGroupModal
          group={selectedGroup}
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setSelectedGroup(null);
          }}
          onSave={() => {
            setIsModalOpen(false);
            setSelectedGroup(null);
          }}
        />
      )}
    </div>
  );
}

export default GroupList;
